export const STATUS_200 = 200;
export const STATUS_300 = 300;
export const STATUS_400 = 400;
export const SEARCH_LIMIT = 50;
export const DATA_LIMIT = 20;
